// frontend/src/utils/normalizeMember.js

import { formatDateForSQL } from './dateUtils'

export const normalizeMemberForBackend = (member) => ({
  nationalId: member.nationalId,
  passport: member.passport,
  firstName: member.firstName,
  middleName: member.middleName,
  lastName: member.lastName,
  secondLastName: member.secondLastName,
  gender: member.gender,
  birthdate: formatDateForSQL(member.birthdate),
  nationality: member.nationality,
  contact: member.contact
});
